import { Image, Page, StyleSheet, Text, View } from '@react-pdf/renderer'
import { useRautReportOps } from 'pages/reporting/reports/raut/RautReportProvider'
import rautGuide from 'pages/reporting/reports/raut/sections/assets/IntroRAUT.png'
import { PageFooter } from 'pages/reporting/shared/pdfGeneration/components/shared/PageFooter'
import { PageHeader } from 'pages/reporting/shared/pdfGeneration/components/shared/PageHeader'
import { PDFStyles } from 'pages/reporting/shared/pdfGeneration/styles/PDFStyles'
import { PdfProps, StaticSection } from 'pages/reporting/shared/types'
import React, { useRef } from 'react'

const styles = StyleSheet.create({
  fullPageContent: {
    flex: 1,
    display: 'flex',
    flexDirection: 'column',
    justifyContent: 'center',
    margin: '10px 10px 10px',
    padding: 0,
  },
  fullPageImageContainer: {
    flex: 1,
    display: 'flex',
    alignItems: 'center',
    justifyContent: 'center',
    width: '100%',
    height: '100%',
  },
  fullPageImage: {
    maxWidth: '100%',
    maxHeight: '100%',
    objectFit: 'contain',
  },
})

const RenderPDF: React.FC<PdfProps> = ({ onRender }) => {
  const hasRegistered = useRef(false)
  const { formData } = useRautReportOps()

  return (
    <Page size='A4' style={PDFStyles.page} id='raut-guide-page'>
      <Text
        render={({ pageNumber }) => {
          if (!hasRegistered.current) {
            onRender({ id: 'raut-guide-page', pageNumber })
            hasRegistered.current = true
          }
          return ''
        }}
      />

      <PageHeader title='Guide to Interpretation of R-AUT Data' />

      <View style={styles.fullPageContent}>
        <View style={styles.fullPageImageContainer}>
          <Image src={rautGuide} style={styles.fullPageImage} />
        </View>
      </View>

      <PageFooter
        jobNumber={formData.coverPageData.geckoJobId}
        revisionNumber={formData.revisionMetadata.revisionNumber}
        prelim={
          !(
            formData.signoff?.reviewerSignoff &&
            formData.signoff.supervisorSignoff
          )
        }
      />
    </Page>
  )
}

export const RAUTGuidePage: StaticSection = {
  id: 'raut-guide-page',
  title: 'Guide to RAUT',
  RenderPDF,
}
